export default __webpack_public_path__ + "static/media/avatar_cheshire_cat9.de9529a7.mp3";